import { useState } from 'react';
import RecipeList from './components/RecipeList';
import RecipeDetail from './components/RecipeDetail';
import RecipeForm from './components/RecipeForm';
import LockScreen from './components/LockScreen';

function App() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [currentView, setCurrentView] = useState('list'); // 'list', 'detail', 'create', 'edit'
  const [selectedRecipeId, setSelectedRecipeId] = useState(null);

  const handleRecipeClick = (recipe) => {
    setSelectedRecipeId(recipe.id);
    setCurrentView('detail');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedRecipeId(null);
  };

  const handleCreateNew = () => {
    setSelectedRecipeId(null);
    setCurrentView('create');
  };

  const handleEdit = (recipeId) => {
    setSelectedRecipeId(recipeId);
    setCurrentView('edit');
  };

  const handleDelete = () => {
    setCurrentView('list');
    setSelectedRecipeId(null);
  };

  const handleFormSuccess = () => {
    setCurrentView('list');
    setSelectedRecipeId(null);
  };

  if (!isUnlocked) {
    return <LockScreen onUnlock={() => setIsUnlocked(true)} />;
  }

  if (currentView === 'detail') {
    return (
      <RecipeDetail
        recipeId={selectedRecipeId}
        onBack={handleBackToList}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    );
  }

  if (currentView === 'create') {
    return (
      <RecipeForm
        onBack={handleBackToList}
        onSuccess={handleFormSuccess}
      />
    );
  }

  if (currentView === 'edit') {
    return (
      <RecipeForm
        recipeId={selectedRecipeId}
        onBack={handleBackToList}
        onSuccess={handleFormSuccess}
      />
    );
  }

  return (
    <RecipeList
      onRecipeClick={handleRecipeClick}
      onCreateNew={handleCreateNew}
      onEdit={handleEdit}
    />
  );
}

export default App;
